module.exports = __webpack_public_path__ + "assets/img/chronicleImg-139c106c.png";